import { OrderRMXUL } from '@cemex-core/cmx-api';
import { createAction, props } from '@ngrx/store';

export enum PricesActionTypes {
  SAVE_PRICES = '[MULTIPLE ORDERS] [PRICES] save prices',
  RESET_PRICES = '[MULTIPLE ORDERS] [PRICES] reset prices',
  SET_DCO_OVERDUE_TIMER = '[MULTIPLE ORDERS] [PRICES] set overdue timer',
}

export const savePrices = createAction(
  PricesActionTypes.SAVE_PRICES,
  props<{
    orderItemsRMS: OrderRMXUL[];
    orderTax: string;
    orderNetValue: string;
  }>(),
);

export const resetPrices = createAction(PricesActionTypes.RESET_PRICES);

export const setDcoOverdueTimer = createAction(
  PricesActionTypes.SET_DCO_OVERDUE_TIMER,
  props<{ minutes: number; seconds: number }>(),
);

export const PricesActions = {
  savePrices,
  resetPrices,
  setDcoOverdueTimer,
};
